import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import {
  DangerButton,
  SecondaryDangerButton,
} from "../../../../components/customComponent";
import { useDispatch, useSelector } from "react-redux";
import { editEquipment } from "../../../store/actions/bplrt/equipmentAction";
import { useTranslation } from "react-i18next";

const RemoveAllBreakdown = () => {
  const dispatch = useDispatch();
  const { equipment } = useSelector((state) => state.bplrtEquip);

  const { t } = useTranslation("bplrtEquipment");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    const equip = equipment.filter((equip) => equip.isDisrupted === true);
    let payload = [];
    equip.forEach((item) => {
      payload.push({ id: item.id, isDisrupted: false });
    });

    dispatch(editEquipment({ equipments: payload }));
    handleClickClose();
  };

  return (
    <>
      <Button
        onClick={handleClickOpen}
        startIcon={<DeleteOutlineIcon fontSize="small" />}
        color="error"
        variant="contained"
        fullWidth
        sx={{ boxShadow: 3 }}
        disabled={equipment.filter((item) => item.isDisrupted).length === 0}
      >
        {t("removeAllBreakdownBtn")}
      </Button>

      <Dialog maxWidth="sm" open={open} onClose={handleClickClose}>
        <DialogContent>
          <DialogContentText
            sx={{
              textAlign: "center",
              mb: 2,
            }}
          >
            {t("removeAllBreakdownConfirmHint")}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <SecondaryDangerButton
            fullWidth
            startIcon={<ClearIcon />}
            onClick={handleClickClose}
          >
            {t("cancelBtn")}
          </SecondaryDangerButton>

          <DangerButton
            fullWidth
            startIcon={<DoneIcon />}
            onClick={handleRemove}
          >
            {t("removeAllBreakdownSubmitBtn")}
          </DangerButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveAllBreakdown;
